import React from 'react'
import { object, func } from 'prop-types'
import { CompleteChallengePopup } from '../../components'

import styles from './UserChallengePage.styl'
// import CompleteChallengePopup from './components/CompleteChallengePopup'

export default class UserChallengePage extends React.Component {
	static propTypes = {
		athlete: object,
		handleSubmit: func
	}
	constructor(props) {
		super(props)
		const { athlete } = props
		this.state = {
			athleteChallenge: {
				goal: athlete.goal,
				currentChallenge: athlete.currentChallenge ? { ...athlete.currentChallenge } : {},
				challengeHistory: athlete.challengeHistory ? [...athlete.challengeHistory] : []
			},
			newChallenge: {
				name: '',
				distance: '',
				date: new Date(),
				time: '',
				DA: '',
				DP: ''
			},
			hasPopup: false
		}
	}
	componentWillReceiveProps(nextProps) {
		const { athlete } = nextProps
		this.setState({
			athleteChallenge: {
				goal: athlete.goal,
				currentChallenge: athlete.currentChallenge ? { ...athlete.currentChallenge } : {},
				challengeHistory: athlete.challengeHistory ? [...athlete.challengeHistory] : []
			}
		})
	}
	currentChallengeRender() {
		const { currentChallenge } = this.state.athleteChallenge
		const condition = !Object.keys(currentChallenge).length
		const options = {
			title: condition ? 'Inserir Desafio' : 'Desafio Atual',
			renderMethod: condition ? this.currentChallengeInput.bind(this) : () => {
				const { name, date, distance, time, DA, DP } = currentChallenge
				return [
					<tr key={ 1 }>
						<td>{ name }</td>
						<td>{ new Date(date).toISOString().slice(0, 10).split('-').reverse().join('-') }</td>
					</tr>,
					<tr key={ 2 }>
						<td>{ distance }</td>
						<td>{ time }</td>
						<td>{ DP }</td>
						<td>{ DA }</td>
					</tr>
				]
			},
			submitMessage: condition ? 'Adicionar Desafio' : 'Desafio Superado'
		}

		return (
			<div className={ styles.table } >
				<h2>{ options.title }</h2>
				<table>
					<thead>
						<tr>
							<th>Objetivo</th>
							<th>Data</th>
						</tr>
					</thead>
					<tbody>
						{ options.renderMethod()[0] }
					</tbody>
				</table>
				<table>
					<thead>
						<tr>
							<th>Distância (km)</th>
							<th>Tempo (m)</th>
							<th>D+ (m)</th>
							<th>DA (m)</th>
						</tr>
					</thead>
					<tbody>
						{ options.renderMethod()[1] }
					</tbody>
				</table>
				<div className={ styles.concluded }>
					<input type="submit" value={ options.submitMessage } />
				</div>
			</div >
		)
	}
	challengeHistory() {
		const { challengeHistory } = this.state.athleteChallenge
		return challengeHistory.map((data, i) => {
			const { name, date, distance, time, recordedTime, recordedDistance } = data
			return (
				<tr key={ i }>
					<td>{ name }</td>
					<td>{ new Date(date).toISOString().slice(0, 10).split('-').reverse().join('-') }</td>
					<td>{ distance }/<span>{ recordedDistance }</span></td>
					<td>{ time }/<span>{ recordedTime }</span></td>
				</tr>
			)
		})
	}
	handleGoalSubmit(e) {
		const { handleSubmit } = this.props
		const { athleteChallenge: { goal } } = this.state
		if (!goal) {
			// window.alert('Introduzir um objetivo!')
			return
		}
		handleSubmit(e, { goal })
	}
	handleSubmit(e) {
		e.preventDefault()
		const { athlete, handleSubmit } = this.props
		const { newChallenge, athleteChallenge } = this.state
		const { currentChallenge } = athleteChallenge
		if (Object.keys(currentChallenge).length) {
			return this.setState({ hasPopup: true })
		}
		if (!newChallenge.name) {
			// window.alert('Por favor introduz o nome do desafio')
			return
		}
		if (!newChallenge.distance) {
			// window.alert('Por favor introduz a distância do desafio')
			return
		}
		if (isNaN(newChallenge.time)) {
			// window.alert('Por favor introduz o tempo válido!')
			return
		}
		handleSubmit(e, {
			...athlete,
			currentChallenge: {
				...newChallenge,
				date: newChallenge.date.getTime()
			}
		})
	}
	completedChallengeSubmit(distance, time) {
		const { athlete, handleSubmit } = this.props
		const { athleteChallenge } = this.state
		const { currentChallenge, challengeHistory } = athleteChallenge
		if (!distance) {
			// window.alert('Por favor introduz a distância do desafio')
			return
		}
		if (isNaN(time)) {
			// window.alert('Por favor introduz o tempo do desafio no formato hh:mm')
			return
		}

		this.setState({
			hasPopup: false,
			athleteChallenge: {
				...athleteChallenge,
				currentChallenge: {}
			},
			newChallenge: {
				name: '',
				distance: '',
				date: new Date(),
				time: '',
				DA: '',
				DP: ''
			}
		})

		const data = {
			...athlete,
			currentChallenge: null,
			challengeHistory: [
				...challengeHistory,
				{
					...currentChallenge,
					recordedTime: time,
					recordedDistance: distance
				}
			]
		}
		handleSubmit('_', data)

	}
	getMonthDays(month, year) {
		if (month.match(/^0|2|4|6|7|9|11/)) {
			return 31
		} else if (month.match(/3|5|8|10/)) {
			return 30
		} else if (year % 4 !== 0) {
			return 28
		} else if (year % 100 !== 0 || year % 400 === 0) {
			return 29
		} else {
			return 28
		}
	}
	currentChallengeInput() {
		const { name, date, distance, time, DA, DP } = this.state.newChallenge
		const handleInputDataChange = (key, value) => {
			this.setState(prevState => {
				const newChallenge = { ...prevState.newChallenge }
				newChallenge[key] = value
				return { newChallenge }
			})
		}
		const days = new Array(this.getMonthDays(date.getMonth().toString())).fill().map((v, i) => <option key={ i } value={ i + 1 }>{ i + 1 }</option>)
		const month = new Array(12).fill().map((v, i) => <option key={ i } value={ i + 1 }>{ i + 1 }</option>)
		const years = new Array(25).fill().map((v, i) => <option key={ i } value={ new Date().getFullYear() + i }>{ new Date().getFullYear() + i }</option>)
		return [
			<tr key={ 1 }>
				<td><input type="text" placeholder="Nome" value={ name } onChange={ (e) => handleInputDataChange('name', e.target.value) } /></td>
				<td>
					<div className={ styles['dadosContainer'] } >
						<select value={ date.getDate() } onChange={ (e) => handleInputDataChange('date', new Date(date.setDate(e.target.value))) }>
							{ days }
						</select>
						<select
							value={ date.getMonth() + 1 } onChange={ (e) => {
								const newMonth = e.target.value - 1
								const newDate = new Date(date)
								if (this.getMonthDays(newMonth.toString()) < date.getDate()) { newDate.setDate(1) }
								newDate.setMonth(e.target.value - 1)
								handleInputDataChange('date', newDate)
							} }
						>
							{ month }
						</select>
						<select value={ date.getFullYear() } onChange={ (e) => handleInputDataChange('date', new Date(date.setFullYear(e.target.value))) }>
							{ years }
						</select>
					</div>
				</td>
			</tr>,
			<tr key={ 2 }>
				<td><input type="number" step="0.01" placeholder="Distância" value={ distance } onChange={ (e) => handleInputDataChange('distance', parseFloat(e.target.value)) } /></td>
				<td><input type="number" step="0.01" placeholder="Tempo" value={ time } onChange={ (e) => handleInputDataChange('time', parseInt(e.target.value, 10)) } /></td>
				<td><input type="number" step="0.01" placeholder="D+" value={ DP } onChange={ (e) => handleInputDataChange('DP', parseInt(e.target.value, 10)) } /></td>
				<td><input type="number" step="0.01" placeholder="DA" value={ DA } onChange={ (e) => handleInputDataChange('DA', parseInt(e.target.value, 10)) } /></td>
			</tr>
		]
	}
	render() {
		const { athleteChallenge, hasPopup } = this.state
		const { goal, challengeHistory, currentChallenge } = athleteChallenge
		return (
			<div className={ styles.dataBox }>
				<div className={ styles['content'] }>
					{ hasPopup ? <CompleteChallengePopup name={ currentChallenge.name } submit={ this.completedChallengeSubmit.bind(this) } /> : null }
					<h2 className={ styles.title }>Objetivos</h2>
					<div className={ styles.table }>
						<h2>Objetivo Atual</h2>
						<textarea value={ goal } onChange={ (e) => { this.setState({ athleteChallenge: { ...athleteChallenge, goal: e.target.value } }) } } />
						<div className={ styles.submitButton }>
							<button onClick={ this.handleGoalSubmit.bind(this) }>Guardar</button>
						</div>
					</div>
					<form onSubmit={ this.handleSubmit.bind(this) }>
						<h2 className={ `${ styles.title } ${ styles.second }` }>Desafios</h2>
						{ this.currentChallengeRender() }
						<div className={ styles.table }>
							<h2>Histórico de Desafios</h2>
							{ challengeHistory.length ?
								<table>
									<thead>
										<tr>
											<th>Objetivo</th>
											<th>Data</th>
											<th>Distância (km)</th>
											<th>Tempo (hh:mm)</th>
										</tr>
									</thead>
									<tbody>
										{ this.challengeHistory() }
									</tbody>
								</table> : <p>Sem dados no histórico</p> }
						</div>
					</form>
				</div>
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/client/webapp/pages/UserChallengePage/UserChallengePage.js